module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/modules/_iterators.js
// module id = 85
// module chunks = 0